<template>
  <!-- 揽收方式 -->
  <el-select
    v-model="val"
    :placeholder="$t('basicData.PleaseSelect')"
    style="width: 100%;"
    clearable
    :disabled="disabled"
  >
    <!--上门交件-->
    <el-option :key="1" :label="$t('collectionCenter.dropOff')" :value="1" />
    <!--上门揽收-->
    <el-option :key="2" :label="$t('collectionCenter.doorPickUp')" :value="2" />
  </el-select>
</template>

<script>
export default {
  model: {
    prop: 'value', // 将默认的 prop 名 value 改为 title
    event: 'change' // 将默认的事件名 input 改为 change
  },

  props: {
    value: {
      type: [String, Number],
      required: true
    },
    businessType: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      disabled: true
    };
  },

  computed: {
    val: {
      // 动态计算值
      get: function() {
        return this.value;
      },
      set: function(val) {
        this.$emit('change', val);
      }
    }
  },

  watch: {
    businessType: {
      handler(val) {
        if (val === 0) {
          this.disabled = false;
          return;
        }
        this.val = '';
        this.disabled = true;
      },
      immediate: true
    }
  }
};
</script>

